// Mirrors Estimates::Computer: amounts are integer cents until formatting.
const VAT_PER_MILLE = { vat_5_5: 55, vat_10: 100, vat_20: 200 }

export function calculateEstimateTotals(lines, { discountType = "none", discountPercentage = 0, discountAmountCents = 0 } = {}) {
  const itemsSubtotalCents = lines.reduce((sum, line) => sum + line.totalCents, 0)
  let globalDiscountCents = 0

  if (discountType === "percentage" && discountPercentage > 0) {
    // The database stores percentages to two decimals. Work in integer basis points
    // so a half-cent such as 12.50 € × 2.28 % cannot become 28.499999… cents.
    const basisPoints = Math.round(discountPercentage * 100)
    globalDiscountCents = Math.floor((itemsSubtotalCents * basisPoints + 5_000) / 10_000)
  } else if (discountType === "fixed" && discountAmountCents > 0) {
    globalDiscountCents = Math.min(discountAmountCents, itemsSubtotalCents)
  }

  const subtotalCents = Math.max(0, itemsSubtotalCents - globalDiscountCents)
  const allocatedDiscounts = lines.map(({ totalCents }, index) => {
    const numerator = totalCents * globalDiscountCents
    return { index, cents: itemsSubtotalCents > 0 ? Math.floor(numerator / itemsSubtotalCents) : 0,
      remainder: itemsSubtotalCents > 0 ? numerator % itemsSubtotalCents : 0 }
  })
  let residual = globalDiscountCents - allocatedDiscounts.reduce((sum, allocation) => sum + allocation.cents, 0)
  for (const allocation of [...allocatedDiscounts].sort((a, b) => b.remainder - a.remainder || a.index - b.index)) {
    if (residual <= 0) break
    allocation.cents += 1
    residual -= 1
  }
  const vatCents = lines.reduce((sum, { totalCents, vatRate }, index) => {
    const discountedCents = totalCents - allocatedDiscounts[index].cents
    return sum + Math.floor((discountedCents * (VAT_PER_MILLE[vatRate] ?? 200) + 500) / 1000)
  }, 0)

  return { itemsSubtotalCents, globalDiscountCents, subtotalCents, vatCents, totalCents: subtotalCents + vatCents }
}
